exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gw-credit-card-input{position:relative}.gw-credit-card-input .gw-cc-icon{position:absolute;top:.75rem;right:0}@media (max-width:46.24em){.gw-credit-card-input .gw-cc-icon{top:1rem}}.gw-credit-card-input .gw-cc-icon>img{width:3em;height:1.875em;display:block;max-width:none}@media (max-width:46.24em){.gw-credit-card-input .gw-cc-icon>img{font-size:12px}}.gw-cc-icon--empty{margin-top:.625rem}@media (max-width:46.24em){.gw-cc-icon--empty{margin-top:.375rem}}.gw-cc-icon--empty svg{width:9em;height:1.125em}@media (max-width:46.24em){.gw-cc-icon--empty svg{font-size:75%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./resources/assets/js/common/forms/credit-card/credit-card.scss
// module id = e1wb
// module chunks = 1